import * as Api from "@modules/api";
import { db } from "@modules/local/db";
import { errorHandler } from "@utils/helpers/errorHandler";

export const getAllowedContentEntitiesAsync = async (): Promise<
  string[] | undefined
> => {
  return errorHandler(async () => {
    const client = new Api.Server.Server_Allowings_Client(
      undefined,
      Api.apiClient
    );

    const response = await client.allowings_ids_get_V1();

    if (response.success && response.data) {
      await db.allowedEntities.bulkPut(
        response.data.map((d) => {
          return {
            id: d,
          };
        })
      );

      return response.data;
    }

    if (response.success && !response.data) {
      throw new Error("No Data");
    }

    throw response.errors;
  });
};

export const ContentEntitiesActions = {
  getAllowedContentEntitiesAsync,
};
